import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/Panel';
import PanelHeader from 'components/Panel/components/PanelHeader';
import PanelBody from 'components/Panel/components/PanelBody';
import StatCard from 'components/Statistics/StatCard';
import ReactECharts from 'echarts-for-react';
import SkeletonBarChart from 'components/Loading/skeletonBarChart';
import { formatNumber } from 'utils/functions';

function SummaryAdminCapTable({ literals, captable = null }) {
  const captableChart = {
    series: [{
      name: literals.operations,
      type: 'line',
      symbol: 'none',
      data: captable?.operationsPerDay?.map(op => op.value) || [],
    }, {
      name: literals.waterfalls,
      type: 'line',
      symbol: 'none',
      data: captable?.waterfallsPerDay?.map(w => w.value) || [],
    }],

    tooltip: {
      trigger: 'axis', valueFormatter: v => formatNumber(v),
    },
    legend: {
      data: [literals.operations, literals.waterfalls],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: captable?.operationsPerDay?.map(op => op.date.substr(5, 6)) || [],
      axisLabel: { rotate: 45 },
    },
    yAxis: {
      type: 'value',
    },
  };

  return (
    <div className='row mb-sp'>
      <div className='col-12 col-md-8'>
        <Panel className='m-0'>
          <PanelHeader title={literals.captable} subtitle={literals.lastMonthActivity} />
          <PanelBody>
            {
              !captable ? (
                <div className='d-flex align-items-center justify-content-center'>
                  <SkeletonBarChart height='200px' />
                </div>
              ) : (
                <ReactECharts option={captableChart} style={{ height: 222 }} />
              )
            }
          </PanelBody>
        </Panel>
      </div>
      <div className='col-12 col-md-4'>
        <div className='d-flex flex-column justify-content-end h-100' style={{ gap: '21px' }}>
          <StatCard
            title={literals.startupsWithCaptable}
            value={captable?.startupsWithCaptable}
            loading={!captable}
          />
          <StatCard
            title={literals.shareholders}
            value={captable?.shareholders}
            loading={!captable}
          />
          <StatCard
            title={literals.shareholdersWithAccess}
            value={captable?.shareholdersWithAccess}
            loading={!captable}
          />
        </div>
      </div>
      <div className='col-12 col-md-4'>
        <StatCard
          title={literals.operations}
          value={captable?.operations}
          loading={!captable}
        />
      </div>
      <div className='col-12 col-md-4'>
        <StatCard
          title={literals.waterfalls}
          value={captable?.waterfalls}
          loading={!captable}
        />
      </div>
      <div className='col-12 col-md-4'>
        <StatCard
          title={literals.syndicates}
          value={captable?.syndicates}
          loading={!captable}
        />
      </div>
    </div>
  );
}

SummaryAdminCapTable.propTypes = {
  literals: PropTypes.object.isRequired,
  captable: PropTypes.object,
};

export default SummaryAdminCapTable;
